// extracted by mini-css-extract-plugin
export default {"authorization":"Authorization-module__authorization--Zvdjv","authorization__inner":"Authorization-module__authorization__inner--OaSrh"};